import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { allCategories } from '@/lib/videos';

export default function MobileTabBar() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const location = useLocation();
  const isCategory = location.pathname.startsWith('/category');

  const itemClass = (active: boolean) =>
    `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${
      active ? 'text-primary-600' : 'text-foreground-500'
    }`;

  return (
    <>
      <nav className="fixed inset-x-0 bottom-0 z-40 flex h-16 items-stretch border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
        <NavLink to="/" end className={({ isActive }) => itemClass(isActive)}>
          <i className="ri-home-5-line text-xl" />
          首页
        </NavLink>

        <button type="button" onClick={() => setSheetOpen(true)} className={itemClass(isCategory)}>
          <i className="ri-apps-2-line text-xl" />
          分类
        </button>

        <NavLink to="/search" className={({ isActive }) => itemClass(isActive)}>
          <i className="ri-search-line text-xl" />
          搜索
        </NavLink>

        <NavLink to="/about" className={({ isActive }) => itemClass(isActive)}>
          <i className="ri-information-line text-xl" />
          关于
        </NavLink>
      </nav>

      {sheetOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <button
            type="button"
            aria-label="关闭分类菜单"
            onClick={() => setSheetOpen(false)}
            className="absolute inset-0 bg-foreground-950/40"
          />
          <div className="absolute inset-x-0 bottom-0 animate-fade-up rounded-t-2xl bg-background-50 p-5 pb-8">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="text-base font-bold text-foreground-950">内容分类</h3>
              <button
                type="button"
                aria-label="关闭"
                onClick={() => setSheetOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-500"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <div className="flex flex-col gap-2">
              {allCategories.map((category) => (
                <Link
                  key={category.key}
                  to={`/category/${category.key}`}
                  onClick={() => setSheetOpen(false)}
                  className="flex items-center gap-3 rounded-lg bg-background-100 p-3"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${category.icon} text-xl`} />
                  </span>
                  <span className="flex flex-col">
                    <span className="text-sm font-bold text-foreground-900">{category.name}</span>
                    <span className="line-clamp-1 text-xs text-foreground-500">
                      {category.description}
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line ml-auto text-lg text-foreground-400" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}